/**
 * A mooring finger below the south quay (lifted from lantern-water's `world.js`
 * `townSurroundings`, the body of its `for (const x of [2, 12])` loop): twenty
 * planks running south from z 17.95, six piles and two cross rails. The root
 * is at the finger's x on the town's z = 0 line (the plank z values stay the
 * prototype's). No params.
 */
import * as THREE from 'three';
import type { Prefab } from './types.ts';

export const prefab: Prefab = {
  id: 'mooring_finger',
  buildPrefab(ctx) {
    const root = new THREE.Group();
    const { box, cylinder, line, m } = ctx;
    for (let i = 0; i < 20; i += 1) box(root, 0, -0.36, 17.95 + i * 0.28, 1.7, 0.12, 0.25, m.wood);
    for (const xx of [-0.68, 0.68]) for (const z of [19.1, 21, 23.2]) cylinder(root, xx, -0.7, z, 0.095, 1.45, m.darkWood);
    for (const z of [19.1, 23.2]) line(root, [-0.7, 0.04, z], [0.7, 0.04, z], 0.035, m.wood);
    return { root };
  },
};
